import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'

class EmailStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            newEmail: undefined,
            toAddr: []
        });
    }
    

    sendEmail = () => {
        console.log('email store ');

        //if ((this.selectedOrg.orgname === null) || (this.selectedOrg.orgname ==="") || (this.selectedOrg.orgname===undefined)) {
        //  alert('Org Name cannot be null, please enter a name');
        //  return false;
        //} 

       
        axios.post('/api/v1/email/sendemail',{
            em: this.newEmail
           })
           .then((response) => {
                                eb.emit('toast', {
                                        status: 'success',
                                        text: 'Email sent successfully'
                                })
                                eb.emit('email-sent');
         }); 

       }

    setToAddr = action((val) => {
       //console.log(val)
       this.newEmail.toaddr = val.split(',');
   })

   
    setSub = action((val) => {
        //console.log(val)
        this.newEmail.sub = val;
    })

    setBody = action((val) => {
        //console.log(val)
        this.newEmail.body = val;
    })
}

const emailstore = new EmailStore();
export default emailstore;



// WEBPACK FOOTER //
// ./src/store/email-store.js